var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row m-0 home p-0"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0"},[_c('div',{staticClass:"container p-0"},[_c('div',{staticClass:"m-0"},[_c('app-lotto-history',{key:_vm.$route.fullPath})],1)])]),_c('div',{staticClass:"col-12 p-0"},[_c('app-lotto')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }